import { Suspense, ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps, Switch } from 'react-router-dom';

import { fomatParentPath, isMobile } from '../../utils';
import {
    Loading,
    // SignUp,
    MSignUp,
    MTeams
} from '../../lib';

function RouteLogin(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    return (
        <Switch weId={`${props.weId || ''}_n9771v`}>
            <Route weId={`${props.weId || ''}_oh0zsb`} path={`${parentPath}/signup/tenant`} component={MTeams} />
            <Route weId={`${props.weId || ''}_nkq7on`} path={`${parentPath}/signup`} component={MSignUp} />
        </Switch>
    )
}

export default withRouter(RouteLogin);
